<template>
    <!-- BaseAvatar.vue -->
    <img :src="imageUrl" @error="handleImageError">
</template>

<script>
    import md5 from 'md5'
    import {DEFAULT_THEME} from '@windsor-telecom-management/client-core/src/config/theme'
    // Components
    import DefaultAvatar from '@windsor-telecom-management/client-core/src/assets/img/base-avatar.png'

    /**
     * Displays a user's Gravatar image or their initials if they do not have one.  Falls back to a standard image if an
     * error happens
     */
    export default {
        name: 'BaseAvatar',
        data: () => ({
            baseFallBackUrl: 'https://ui-avatars.com/api',
            imageUrl: DefaultAvatar
        }),
        props: {
            /**
             * The theme color of the fallback icon
             */
            color: {
                type: String,
                default: 'primary'
            },
            /**
             * The default fallback avatar.  Must be a local image
             */
            defaultAvatar: {
                type: String,
                default: DefaultAvatar
            },
            /**
             * The email address of the user.  Used to match against gravatar
             */
            email: {
                type: String,
                default: null
            },
            /**
             * Disable gravatar and use the fallback avatar
             */
            forceFallback: {
                type: Boolean,
                default: false
            },
            /**
             * Person's name.
             */
            name: {
                type: String,
                default: 'John Doe'
            },
            /**
             * Size in pixels of the Gravatar.
             */
            size: {
                type: Number,
                default: 100
            }
        },
        computed: {
            fallBackUrl () {
                const vm = this
                const base = vm.baseFallBackUrl
                const name = vm.name.replace(' ', '+')
                const size = vm.size
                const themeColor = DEFAULT_THEME[vm.color] || DEFAULT_THEME.primary
                const background = themeColor.replace('#', '')
                const color = 'fff'
                const length = 2
                const fontSize = 0.5
                const rounded = true
                return encodeURIComponent([base, name, size, background, color, length, fontSize, rounded].join('/'))
            },
            initials () {
                const vm = this
                const nameParts = vm.name.split(' ')

                return `${nameParts[0]}${nameParts[1]}`
            },
            url () {
                const vm = this
                let fallbackUrl = vm.fallBackUrl

                if (vm.forceFallback) {
                    return decodeURIComponent(vm.fallBackUrl)
                }

                fallbackUrl = '&d=' + (vm.initials ? fallbackUrl : 'mm')

                const email = null === vm.email ? '' : vm.email
                return `https://www.gravatar.com/avatar/${md5(email)}?s=${vm.size}${fallbackUrl}`
            }
        },
        methods: {
            handleImageError () {
                const vm = this
                vm.imageUrl = vm.defaultAvatar
            }
        },
        watch: {
            url (newVal, oldVal) {
                const vm = this
                if (newVal !== oldVal) {
                    vm.imageUrl = newVal
                }
            }
        },
        mounted () {
            const vm = this
            vm.imageUrl = vm.url
        }
    }
</script>
